import GUI from "lil-gui";
import Stats from "stats.js";

export default class Debug {
    constructor() {
        this.active =
            window.location.hash === "#debug" ||
            window.location.hostname === "localhost" ||
            window.location.hostname === "127.0.0.1";

        if (this.active) {
            this.ui = new GUI();
            this.stats = new Stats();
            this.stats.showPanel(0); // 0: fps, 1: ms, 2: mb, 3+: custom
            document.body.appendChild(this.stats.dom);
        }
    }

    update() {
        if (this.active && this.stats) {
            this.stats.update();
        }
    }

    destroy() {
        if (this.active) {
            this.ui.destroy();
            document.body.removeChild(this.stats.dom);
        }
    }
}
